<template>
    <div class="line-charts">
        <div class="top-box" type="flex">
            <span class="title">{{title}}</span>
            <div>
                <el-select v-model="currentSubType" v-if="subGroupDatas.length > 1" size="mini" style="width: 100px; margin-right: 10px;">
                    <el-option v-for="item in subGroupDatas" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="currentStatsType" placeholder="过滤方式" size="mini" style="margin-right: 10px; width: 100px;"
                    v-if="statsTypeList.length > 1" @change="onStatsTypeChange">
                    <el-option label="日统计" value="day" v-if="statsTypeList.indexOf('day') !== -1" />
                    <el-option label="月统计" value="month" v-if="statsTypeList.indexOf('month') !== -1" />
                    <el-option label="年统计" value="year" v-if="statsTypeList.indexOf('year') !== -1" />
                </el-select>
            </div>
        </div>
        <ve-line :data="chartData" :settings="chartSetting" :height="height" :after-config="onAfterConfig" :extend="baseOptions"
            :after-set-option-once="onSetOption"></ve-line>
    </div>
</template>

<script>
import baseChartsMixins from '@/components/BaseCharts/chartBaseMixins.js';

export default {
    name: 'LineChart',
    mixins: [baseChartsMixins],
    props: {
        baseOptions: {
            type: Object,
            default: () => {
                return {
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '20px',
                        containLabel: true
                    },
                    xAxis: {
                        axisLabel:{
                            interval: 0,
                            showMaxLabel: true
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
    .line-charts {
        border: 1px solid rgb(220, 223, 230);
    }

    .top-box {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid rgb(220, 223, 230);
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .title {
        color: black;
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/LineChart/index.vue